import React from 'react';

const OfferingCard = ({ offeringKey, title, text, openModal, modalContents }) => (
    <div className="offering-card">
        <h3>{title}</h3>
        <p className="offering-text">{text}</p>
        <button className="read-more-btn" onClick={() => openModal('offeringDetails', modalContents[offeringKey])}>
            കൂടുതൽ വായിക്കുക
        </button>
    </div>
);

const Offerings = ({ openModal, modalContents }) => (
    <div className="page" id="page4">
        <h2 className="content-title">വഴിപാടുകൾ</h2>
        <div className="offerings-grid">
            <OfferingCard
                offeringKey="kedavilakku"
                title="കെടാവിളക്ക്"
                text="ശ്രീ തലയന്നേരി പൂമാല ഭഗവതി കാവിലെ ആചാരാനുഷ്ഠാനങ്ങളിൽ ഏറ്റവും ശ്രേഷ്ഠമായത് ഗർഭഗൃഹത്തിൽ പ്രകാശിച്ചു കൊണ്ടിരിക്കുന്ന കെടാ ദീപമാണ്..."
                openModal={openModal}
                modalContents={modalContents}
            />
            <OfferingCard
                offeringKey="chovvavilakku"
                title="ചൊവ്വ വിളക്ക് അടിയന്തിരം"
                text="അഭിഷ്ഠ സിദ്ദിക്കായി ഭക്തജനങ്ങൾ കാവിൽ നടത്തുന്ന പ്രധാന വഴിപാടാണ് ചൊവ്വവിളക്ക് അടിയന്തിരം. വൃശ്ചിക മാസം മുതൽ ചൊവ്വാഴ്ചകളിലാണ് അടിയന്തിരം നടത്തുന്നത്..."
                openModal={openModal}
                modalContents={modalContents}
            />
            <OfferingCard
                offeringKey="commonofferings"
                title="വലിയ കഞ്ഞി"
                text="ക്ഷേത്രത്തിൽ മറ്റ് നിരവധി വഴിപാടുകളും നടത്തപ്പെടുന്നു. ഭക്തർക്ക് അവരുടെ ഇഷ്ടത്തിനനുസരിച്ച് നെയ്‌വിളക്ക്, പുഷ്പാഞ്ജലി, അർച്ചന തുടങ്ങിയ വഴിപാടുകൾ സമർപ്പിക്കാവുന്നതാണ്..."
                openModal={openModal}
                modalContents={modalContents}
            />
        </div>
    </div>
);

export default Offerings;